module.exports = __webpack_public_path__ + "static/media/icon-supplies-largecomb.55dd6c10.svg";